import { makeStyles } from 'tss-react/mui';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    height: '100%',
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  btns: {
    display: 'flex',
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      marginTop: 'auto',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      flexDirection: 'column',
    },
  },

  btn: {
    '&.MuiButton-outlined': {
      '&:before': {
        background: theme.gradient.g1,
      },
    },
  },
}));

export default useStyles;
